import script from "./LoadingText.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingText.vue?vue&type=script&setup=true&lang=js"

import "./LoadingText.vue?vue&type=style&index=0&id=b1a83f32&lang=css"

const __exports__ = script;

export default __exports__